import React, { useContext } from 'react';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import DashboardTemplate from 'src/templates/DashboardTemplate';
import MainRoutes from 'src/routes/MainRoutes';
import { AuthContext } from 'src/AuthProvider';

export default function App() {
	const { loadingRefresh, } = useContext(AuthContext);

	if (loadingRefresh) {
		return (
			<DashboardTemplate>
				<Spin
					fullscreen
					indicator={
						<LoadingOutlined
							style={{ color: 'white', fontSize: 35, }}
						/>
					}
					tip={'Estamos preparando tudo...'}
				/>
			</DashboardTemplate>
		);
	}

	return <MainRoutes />;
}
